import { createContext, useContext } from 'react'

export type HeroColorKey =
  | 'sales'
  | 'salesMarginUp'
  | 'salesMarginDown'
  | 'service'
  | 'customer'

export interface HeroContextValue {
  onHero: boolean
  heroColor?: HeroColorKey
}

export const HeroContext = createContext<HeroContextValue>({ onHero: false })

export function useHero(): HeroContextValue {
  return useContext(HeroContext)
}
